module.exports = __webpack_public_path__ + "media/images/eyecatch-pamphlet-2a61576800c8414022b70f0dc79716c0.png";